module.exports = __webpack_public_path__ + "img/year-in-pixels.jpg_w545.ff1f07d7.jpg";